import { Component } from '@angular/core';

@Component({
  selector: 'app-shopping-food',
  imports: [],
  templateUrl: './shopping-food.component.html',
  styleUrl: './shopping-food.component.scss'
})
export class ShoppingFoodComponent {

}
